import React from 'react';
import { IconButton } from '@mui/material';
import { PVWhite, PVNavy, PVGray } from '@pv/common/colors';
import { Star } from 'react-feather';

export const FavoriteButton = ({
  isFavorited,
  onClick,
}: {
  isFavorited: boolean;
  onClick: (e: React.MouseEvent) => void;
}) => {
  return (
    <IconButton
      onClick={onClick}
      sx={{
        backgroundColor: PVWhite,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        border: '1px solid',
        borderColor: 'divider',
        '&:hover': {
          backgroundColor: '#f5f5f5',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
          transform: 'scale(1.05)',
        },
        '&:active': {
          transform: 'scale(0.95)',
        },
        transition: 'all 0.2s ease-in-out',
      }}
    >
      <Star
        size={16}
        fill={isFavorited ? PVNavy : 'none'}
        color={isFavorited ? PVNavy : PVGray}
      />
    </IconButton>
  );
};
